import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Mixins, Prop } from "vue-property-decorator";
import { RlCarousel } from "vue-renderless-carousel";
// SYSTEM1
import BaseMixer from "@/router/views/BaseMixer";
let VueCarouselProjects = /** @class */ (() => {
    let VueCarouselProjects = class VueCarouselProjects extends Mixins(BaseMixer) {
        constructor() {
            // @Prop()
            // public projectList: ProjectAnalyticsTreeViewModel[];
            super(...arguments);
            this.animateLeft = false;
            this.animateRight = false;
        }
        //computed
        //Methods
        projectSelection(projectId) {
            this.$emit("project-selection", projectId);
        }
        triggerAnimation(direction) {
            this[`animate${direction}`] = true;
            setTimeout(() => {
                this[`animate${direction}`] = false;
            }, 1000);
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", Number)
    ], VueCarouselProjects.prototype, "slide", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], VueCarouselProjects.prototype, "projectsCarousel", void 0);
    VueCarouselProjects = __decorate([
        Component({
            name: "VueCarouselProjects",
            components: {
                RlCarousel,
            },
        })
    ], VueCarouselProjects);
    return VueCarouselProjects;
})();
export default VueCarouselProjects;
